import {
  Ban,
  CheckCircle2,
  Clock,
  FileWarning,
  Loader2,
  TimerOff,
  XCircle,
} from "lucide-react";
import { OptroImportItemStatus } from "../models/audit/optroSync";

// The icon at the start of an import item's row in the progress card.
export const OptroImportStatusIcon = ({
  status,
}: {
  status: OptroImportItemStatus;
}) => {
  switch (status) {
    case "queued":
      return <Clock className="h-3.5 w-3.5 text-stone-400" />;
    case "processing":
      return <Loader2 className="h-3.5 w-3.5 animate-spin text-blue-500" />;
    case "complete":
      return <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />;
    case "no_workpaper":
      return <FileWarning className="h-3.5 w-3.5 text-amber-500" />;
    case "failed":
      return <XCircle className="h-3.5 w-3.5 text-red-500" />;
    case "timed_out":
      return <TimerOff className="h-3.5 w-3.5 text-red-500" />;
    case "cancelled":
      return <Ban className="h-3.5 w-3.5 text-stone-400" />;
  }
};
